import { ChevronRight } from 'lucide-react';
import { ILE_PATH } from './ile/ileShape';
import MissionDuJour from './MissionDuJour';

/**
 * Accueil (onglet « Jouer »). PANNEAU de contenu : le fond + le header (HUD) +
 * la tabbar viennent du shell (EspaceEleve). Contenu **centré verticalement**
 * (corrige « trop haut »), responsive 1 col (mobile/tablette) / 2 col (xl).
 * Footer toujours en bas : liens légaux + déconnexion UNIQUEMENT non-GAR.
 */
function HomeEleve({ prenom, counts, nextQuizTitre, onCommencer, onOpenIle, onResultats }) {
  const total = (counts?.maths || 0) + (counts?.francais || 0);

  return (
    <div className="flex-1 flex flex-col w-full px-5 sm:px-6 xl:px-10 py-6">
      {/* Contenu centré verticalement */}
      <div className="flex-1 flex flex-col justify-center">
        <div className="w-full max-w-md xl:max-w-4xl mx-auto flex flex-col gap-4 xl:grid xl:grid-cols-2 xl:gap-x-8 xl:gap-y-4 xl:items-start">
          {/* ── Colonne gauche : intro + actions ── */}
          <div className="flex flex-col gap-4">
            <div>
              <h1 className="text-white text-[26px] leading-tight">Salut {prenom} 👋</h1>
              <p className="text-sm font-bold" style={{ color: 'rgba(255,255,255,.7)' }}>
                Prêt pour ta mission du jour ?
              </p>
            </div>


            {/* Mission du jour (flamme en danger / mission / tout fait / repos) */}
            <MissionDuJour total={total} nextQuizTitre={nextQuizTitre} />

            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-2xl p-4 text-center" style={{ background: 'rgba(255,255,255,.06)' }}>
                <div className="text-2xl font-extrabold text-white" style={{ fontFamily: 'Fredoka' }}>🔢 {counts?.maths || 0}</div>
                <div className="text-[11px] font-bold mt-0.5" style={{ color: 'rgba(255,255,255,.6)' }}>en maths</div>
              </div>
              <div className="rounded-2xl p-4 text-center" style={{ background: 'rgba(255,255,255,.06)' }}>
                <div className="text-2xl font-extrabold text-white" style={{ fontFamily: 'Fredoka' }}>📖 {counts?.francais || 0}</div>
                <div className="text-[11px] font-bold mt-0.5" style={{ color: 'rgba(255,255,255,.6)' }}>en français</div>
              </div>
            </div>

            <button
              type="button"
              onClick={onCommencer}
              className="eleve-cta w-full rounded-2xl p-4 flex items-center justify-center gap-3"
              style={{ background: '#fff', borderBottom: '5px solid #D98A0E' }}
            >
              <span className="w-11 h-11 rounded-full flex items-center justify-center text-xl" style={{ background: 'linear-gradient(120deg,#F97316,#FFB938)' }}>▶️</span>
              <span className="text-left">
                <span className="block text-[18px] font-bold" style={{ fontFamily: 'Fredoka', color: '#0A1F3D' }}>Commencer</span>
                <span className="block text-xs font-bold" style={{ color: '#4A5A6E' }}>On y va, direction ton île !</span>
              </span>
            </button>
          </div>

          {/* ── Colonne droite : aperçu île + lien résultats ── */}
          <div className="flex flex-col gap-4">
            <button
              type="button"
              onClick={onOpenIle}
              className="w-full rounded-2xl p-4 text-left"
              style={{ background: 'rgba(255,255,255,.06)', border: '1px solid rgba(255,255,255,.1)' }}
            >
              <div className="flex items-center justify-between mb-2.5">
                <span className="text-white font-bold text-[15px]" style={{ fontFamily: 'Fredoka' }}>🏝️ L'Île des Défis</span>
                <span className="text-xs font-extrabold flex items-center gap-0.5" style={{ color: '#29B6E8' }}>
                  explorer <ChevronRight className="w-3.5 h-3.5" />
                </span>
              </div>
              <div className="rounded-xl overflow-hidden" style={{ background: 'rgba(0,0,0,.18)' }}>
                <svg viewBox="0 0 160 120" className="w-full h-auto block">
                  <ellipse cx="80" cy="62" rx="74" ry="52" fill="#1A4574" opacity=".4" />
                  <path d={ILE_PATH} fill="#EAF3FB" stroke="#29B6E8" strokeWidth="1.6" strokeLinejoin="round" />
                  <ellipse cx="74" cy="56" rx="38" ry="28" fill="#29B6E8" opacity=".08" />
                  <g className="eleve-fwave">
                    <line x1="58" y1="40" x2="58" y2="50" stroke="#0A1F3D" strokeWidth="1.6" />
                    <path d="M58,33 L71,38 L58,43 Z" fill="#F97316" stroke="#fff" strokeWidth="1" />
                  </g>
                  <g className="eleve-fwave">
                    <line x1="101" y1="60" x2="101" y2="70" stroke="#0A1F3D" strokeWidth="1.6" />
                    <path d="M101,53 L114,58 L101,63 Z" fill="#F97316" stroke="#fff" strokeWidth="1" />
                  </g>
                </svg>
              </div>
              <p className="text-[11px] font-bold mt-2" style={{ color: 'rgba(255,255,255,.55)' }}>
                {total > 0 ? `${total} quiz t'attendent sur l'île.` : 'Les quiz de tes profs + les régions de tes défis.'}
              </p>
            </button>

            <button type="button" onClick={onResultats} className="text-xs font-bold self-center xl:self-start" style={{ color: 'rgba(255,255,255,.6)' }}>
              📊 Mes résultats
            </button>
          </div>
        </div>
      </div>

    </div>
  );
}

export default HomeEleve;
